import { render, staticRenderFns } from "./GridsModal.vue?vue&type=template&id=1068d30d&scoped=true"
import script from "./GridsModal.vue?vue&type=script&lang=js"
export * from "./GridsModal.vue?vue&type=script&lang=js"
import style0 from "./GridsModal.vue?vue&type=style&index=0&id=1068d30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1068d30d",
  null
  
)

export default component.exports